import React from 'react'
import { Link } from 'gatsby'

export default function Violator(){
    return(
        <Link
            to='/sale'
            className='m-0 d-block text-center text-black fw-bold position-relative text-decoration-none'
            style={{ zIndex: 4, textWrapStyle: 'balance', background: '#6BDCFF' }}
        >
            SPEND MORE, SAVE UP TO AN EXTRA 25% — SHOP THE SALE!
        </Link>
    )
}
